<template>

  <div>
    <head-top></head-top>
    <el-row style="margin-top: 20px;" v-loading="loading">
      <el-col :span="20">
        <el-form :model="formData"  ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="formData.name" maxlength="15" placeholder="不超过15字，不能有特殊字符或空格" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="商品分类" prop="classify">
            <el-select v-model="formData.classify" placeholder="请选择" style="width: 200px">
              <el-option
                v-for="item in options1"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否上架" prop="sell">
            <el-select v-model="formData.sell" placeholder="请选择" style="width: 200px">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库存数量" prop="stock">
            <el-input v-model="formData.stock" value="1" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="积分数量" prop="name" style="width: 200px">
            <el-input v-model="formData.number" value="1"></el-input>
          </el-form-item>
          <el-form-item label="商品封面" prop="img">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='handlesuccess'
              :before-upload="beforeUploadimg"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:1}"
              :on-exceed="handleExceed">
              <img v-if="dialogImageUrl" :src="dialogImageUrl" controls="controls" class="avatar">
              <el-button size="small" type="primary" v-if="dialogVisible">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="详情图片" prop="img">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemoves"
              :on-success='handlesuccesss'
              :before-upload="beforeUploadimg"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:1}"
              :on-exceed="handleExceed">
              <img v-if="dialogImageUrls" :src="dialogImageUrls" controls="controls" class="avatar">
              <el-button size="small" type="primary" v-if="dialogVisible2">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="商品描述">
            <el-button size="small" type="primary"  @click="dialogFormVisible4 = true">添加教程</el-button>

          </el-form-item>
          <el-table
            :data="tablesData"
            style="width: 100%;margin-left:60px;">
            <el-table-column
              type="index"
              label="序号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="description"
              label="描述"
              width="180">
            </el-table-column>
            <el-table-column
              prop="imageUrl"
              label="图片地址">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="Viewmaterials(scope.$index, scope.row)">查看</el-button>
                <el-button size="mini" type="text" @click="Editmaterials(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="text" @click="handleDeletes(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--添加图文教程-->
          <el-dialog title="商品描述" :visible.sync="dialogFormVisible4">
            <el-form>
              <el-form-item label="描述" :label-width="formLabelWidth2">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="Godaddy.name">
                </el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='Godaddysuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="Godaddy.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel1">取 消</el-button>
              <el-button type="primary" @click="Godaddys()">确 定</el-button>
            </div>
          </el-dialog>
          <!--查看图文教程-->
          <el-dialog title="查看教程" :visible.sync="dialogFormVisible5">
            <el-form >
              <el-form-item label="描述" width="300px">
                <span>{{Godaddy.name}}</span>
              </el-form-item>
              <el-form-item label="图片附件" class="mar" >
                <img v-bind:src="Godaddy.img" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" >
              <el-button @click="dialogFormVisible5 = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible5 = false">确 定</el-button>
            </div>
          </el-dialog>
          <!--修改图文教程-->
          <el-dialog title="编辑教程" :visible.sync="dialogFormVisible6">
            <el-form>
              <el-form-item label="课程描述" :label-width="formLabelWidth">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="Godaddy.name">
                </el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='Godaddysuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="Godaddy.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <div slot="tip" class="el-upload__tip">请上传688×326的jpg/png图片，且不超过500kb</div>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="图片附件:" prop="img" :label-width="formLabelWidth">
                <img v-bind:src="Godaddy.img" style="width: 80%">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible4 = false">取 消</el-button>
              <el-button type="primary" @click="Godaddysubmit()">确 定</el-button>
            </div>
          </el-dialog>
          <div class="but_bot">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import { getGoodsimfo,getComclassification,getModGoodsimfo } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        options1: [],
        options2:[{
          value: '0',
          label: '下架',
        }, {
          value: '1',
          label: '上架',
        }],
        detailContent: '',// 富文本内容
        formData: {
          classify:'',
          sell:''
        },
        formLabelWidth: '80px',
        formLabelWidth2: '40px',
        imageUrl:'',
        currentPage:1,
        limit:20,
        tablesData: [],
        tablesDats: {},
        tablesDataDel:[],
        dialogFormVisible4:false,
        dialogFormVisible5:false,
        dialogFormVisible6:false,
        Godaddy:{
          name:'',
          img:''
        },
        fileList:[],
        inde:0,
        dialogImageUrl:'',
        detailsImage:'',
        dialogVisible:false,
        dialogVisible2:false,
        myHeaders: {token: sessionStorage.token},
        state:'',
        num:'',
        loading:false,
        value: '',
        dialogImageUrls:''
      }
    },
    components: {
      headTop,
    },
    methods:{
      //获取商品详情
      getinformation(){
        let params = {
          goodsId:this.$route.query.goodsId
        }
        getGoodsimfo(params).then(res=>{
          this.formData.name = res.goodsName
          this.formData.classify = res.typeId
          this.formData.stock= res.stock
          this.formData.number = res.integral
          this.formData.sell= JSON.stringify(res.sell)
          this.tablesData = res.list
          this.dialogImageUrl = res.imageUrl
          this.dialogImageUrls = res.detailsImage
          this.detailsImage = res.detailsImage
          this.imageUrl = res.imageUrl
          this.inde = res.list[res.list.length-1].sort+1
        }).catch(error=>{
        })
      },
      getComclassification(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        //获取商品分类列表
        getComclassification(params).then(res=>{
          this.options1 = res.pageInfo
        }).catch(error=>{
          console.log(error);
        })
      },
      handlesuccess(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.imageUrl = file.response.url
          this.dialogImageUrl = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      handlesuccesss(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.detailsImage = file.response.url
          this.dialogImageUrls = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      Godaddysuccess(response, file, fileList){
        if(file.response.state == true){
          this.Godaddy.img = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      handleExceed(files, fileList) {
        this.$message.warning(`最多上传一张封面`);
      },
      handleRemove(file, fileList) {
        this.dialogImageUrl = ''
        this.Godaddy.img = ''
        this.dialogVisible = true
      },
       handleRemoves(file, fileList) {
        this.dialogVisible2 = true
      },
      beforeUploadimg(file) {
        if (['image/jpeg', 'image/png'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的图片格式');
          return false
        }
      },
      Viewmaterials(index,row){
        //  查看图文教程
        this.dialogFormVisible5 = true
        this.Godaddy.name = row.description,
        this.Godaddy.img = row.imageUrl
      },

      Godaddys(){
        // if(this.Godaddy.name == '' || this.Godaddy.img == ''){
        //   this.$message({
        //     type: 'error',
        //     message: '请上传完整信息'
        //   });
        // } else {
          const tablesData = {}
          tablesData.sort = this.inde++
          tablesData.description = this.Godaddy.name.replace(/ /g, "/t");
          tablesData.imageUrl = this.Godaddy.img;
          this.tablesData.push(tablesData);
          for (var i = 0; i < this.tablesData.length; i++) {
            if (this.tablesDataDel.indexOf(this.tablesData[i]) == -1) {
              this.tablesDataDel.push(this.tablesData[i]);
            }
          }
          this.Godaddy = {
            name: '',
            img: ''
          }
          this.fileList = []
          this.dialogFormVisible4 = false
        // }
      },
      Editmaterials(index,row){
        //  编辑图文教程
        this.dialogFormVisible6 = true
        this.Godaddy.name = row.description
        this.Godaddy.img = row.imageUrl
        this.Godaddy.sort = row.sort
        this.num = index
      },
      Godaddysubmit(index,row){
        this.tablesData[this.num].sort = this.Godaddy.sort
        this.tablesData[this.num].description = this.Godaddy.name.replace(/ /g, "/t");
        this.tablesData[this.num].imageUrl = this.Godaddy.img;
        for(var i = 0; i < this.tablesData.length; i++){
          if(this.tablesDataDel.indexOf(this.tablesData[i]) == -1){
            this.tablesDataDel.push(this.tablesData[i]);
          }
        }
        this.Godaddy = {
          name:'',
          img:''
        }
        this.fileList = [],
        this.dialogFormVisible6 = false
      },
      cancel1(){
        this.Godaddy = {
          name: '',
          img: ''
        }
        this.fileList = [],
        this.dialogFormVisible4 = false
      },
      //提交
      submit(){
        if (this.formData.number <= 0 || this.formData.stock < 0){
            this.$message({
              type: 'error',
              message: '积分不能为负数和零，库存不能为负数'
            });
          }else {
            this.loading = true
            let params = {
              description: JSON.stringify(this.tablesDataDel),
              goodsName: this.formData.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, ''),
              typeId: this.formData.classify,
              imageUrl: this.imageUrl,
              integral: this.formData.number,
              detailsImage:this.detailsImage,
              operationId: JSON.parse(sessionStorage.getItem('user')).id,
              goodsId: this.$route.query.goodsId,
              sell:this.formData.sell,
              stock:this.formData.stock
            }
            getModGoodsimfo(params).then((res) => {
              if (res.state == true) {
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                this.loading = false
                this.getinformation()
              } else {
                this.$message({
                  type: 'error',
                  message: '请上传完整信息'
                });
                this.loading = false
              }
            }).catch(error => {
              this.loading = false
              console.log(error)
            })
          }
      },
      //  删除图文教程
      handleDeletes(index,row){
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          row.state = 0
          for(var i = 0; i < this.tablesData.length; i++){
            if(this.tablesDataDel.indexOf(this.tablesData[i]) == -1){
              this.tablesDataDel.push(this.tablesData[i]);
            }
          }
          this.tablesData.splice(index, 1);
        }).catch(() => {
        })
      },
      //取消
      cancel(){
        this.reload()
        this.$router.push('management')
      },
    },
    computed: {
    },
    activated () {
      this.getComclassification()
      this.getinformation()
    },

  }
</script>
<style>
  .edit_container{
    padding: 40px;
    margin-bottom: 40px;
  }
  .editer{
    height: 300px;
  }
  .mar{
    margin-top:20px;
  }
  .el-input__inner{
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/page/modGoods.vue